import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}

export async function getInfo(params) {
    try {
      return await API.post("/api/" + prout + "/api/questionnaire/info", params);
    } catch (error) {
      return error;
    }
}

export async function get_question_website(params) {
  try {
    return await API.post("/api/" + prout + "/api/questionnaire/get_question_website", params);
  } catch (error) {
    return error;
  }
}



export async function getQuestionData(params) {
    try {
      return await API.post("/api/" + prout + "/api/questionsubject/getQuestionSubject", params);
    } catch (error) {
      return error;
    }
}

export async function getQuestionCountry() {
  try {
    return await API.post("/api/" + prout + "/api/questionnaire/get_question_country", );
  } catch (error) {
    return error;
  }
}
export async function getAreacode(params) {
  try {
    return await API.post("/api/" + prout + "/api/questionnaire/get_areacode", params);
  } catch (error) {
    return error;
  }
}

export async function isAnswer(params, config = {}) {
  try {
    return await API.post("/api/" + prout + "/api/questionanwser/is_answer", params, config);
  } catch (error) {
    return error;
  }
}

export async function isAnswerLogin(params, config = {}) {
  try {
    return await API.post("/api/" + prout + "/api/questionanwser/is_answer_login", params, config);
  } catch (error) {
      return error;
    }
  }
  
export async function sendMbileCode(params) {
  try {
    return await API.post("/api/" + prout + "/tool/get_sms_captcha", params);
  } catch (error) {
    return error;
  }
}

export async function sendCodeEmail(params) {
  try {
    return await API.post("/api/" + prout + "/tool/get_email_code", params);
  } catch (error) {
    return error;
  }
}

export async function getUserInfoSet() {
  try {
    return await API.post("/api/" + prout + "/api/questionnaire/get_user_info_set", );
  } catch (error) {
    return error;
  }
}

export async function answerCheckCode(params) {
  try {
    return await API.post("/api/" + prout + "/api/questionanwser/answercheckcode", params);
  } catch (error) {
    return error;
  }
}
export async function answerAdd(params) {
  try {
    return await API.post("/api/" + prout + "/api/questionanwser/answer_user_add", params);
  } catch (error) {
    return error;
  }
}

export async function getAgreen(params) {
  try {
    return await API.post("/api/" + prout + "/api/questionnaire/get_agreen", params);
  } catch (error) {
    return error;
  }
}




